import { render, staticRenderFns } from "./DataSensor.vue?vue&type=template&id=a545d4b6"
import script from "./DataSensor.vue?vue&type=script&lang=js"
export * from "./DataSensor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports